import { api } from './api';

/**
 * The email wording editor's calls (D-357).
 *
 * Kept out of `api.ts` because nothing else uses them; the shapes mirror
 * `apps/api/src/email/wording-versions.ts`.
 */

export interface EmailWordingVersion {
  id: string;
  template_code: string;
  version: number;
  status: 'DRAFT' | 'ACTIVE' | 'SUPERSEDED';
  subject: string | null;
  intro: string | null;
  closing: string | null;
  change_note: string | null;
  activated_at: string | null;
  superseded_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface EmailWordingTemplate {
  code: string;
  name: string;
  description: string;
  /** False for the two emails that go to staff rather than customers. */
  editable: boolean;
  placeholders: { name: string; label: string }[];
  active: EmailWordingVersion | null;
  draft: EmailWordingVersion | null;
}

export interface EmailWordingInput {
  subject: string | null;
  intro: string | null;
  closing: string | null;
}

export interface RenderedEmailPreview {
  subject: string;
  text: string;
  html: string;
}

const base = (code: string) => `/api/admin/email-wording/${encodeURIComponent(code)}`;

export const emailWordingEndpoints = {
  list: () => api.get<{ templates: EmailWordingTemplate[] }>('/api/admin/email-wording'),
  detail: (code: string) => api.get<{ template: EmailWordingTemplate; versions: EmailWordingVersion[] }>(base(code)),
  saveDraft: (code: string, input: EmailWordingInput & { change_note: string | null }) => api.put<{ draft: EmailWordingVersion }>(`${base(code)}/draft`, input),
  discardDraft: (code: string) => api.delete<{ discarded: boolean }>(`${base(code)}/draft`),
  publish: (code: string) => api.post<{ active: EmailWordingVersion }>(`${base(code)}/publish`, {}),
  revert: (code: string) => api.post<{ reverted: boolean }>(`${base(code)}/revert`, {}),
  preview: (code: string, input: EmailWordingInput) => api.post<{ email: RenderedEmailPreview }>(`${base(code)}/preview`, input),
};
